<script setup lang="ts">
import "ui-kit/UkAppWrapper";
import { disableIOSTextFieldZoom } from "ui-kit/DisableIOSZoom";
import { useVueRouter } from "ui-kit/RouterVue";
import { navigateReplace } from "@/router/helpers.ts";
import { computed, defineAsyncComponent } from "vue";
import routes from "@/router/routes.ts";
import { useAuthStore } from "./state/auth.ts";
// FIXME: remove this after layout redesign
const html = document.documentElement;
html.setAttribute("data-bs-theme", "light");
html.setAttribute("data-sidebar", "dark");
html.setAttribute("data-sidebar-image", "none");
html.setAttribute("data-layout-style", "default");
html.setAttribute("data-layout-position", "fixed");
html.setAttribute("data-sidebar-size", "lg");
html.setAttribute("data-topbar", "dark");
html.setAttribute("data-layout-width", "fluid");
html.setAttribute("data-layout", "horizontal");
html.setAttribute("data-sidebar-visibility", "show");
html.setAttribute("data-preloader", "disable");

disableIOSTextFieldZoom();

function getLocalData(id: string) {
  const data = localStorage.getItem(`crm-data-${id}`);
  return Promise.resolve(data ? JSON.parse(data) : undefined) as any;
}

function setLocalData(id: string, data: any) {
  return Promise.resolve(
    localStorage.setItem(`crm-data-${id}`, JSON.stringify(data))
  );
}
let userStoreInitialised = false;
const authStore = useAuthStore();
if (!userStoreInitialised) {
  userStoreInitialised = true;
  authStore.initStore();
}
const isAuthorised = computed(() => authStore.isAuthorised);

const { el, ready } = useVueRouter(routes, {
  notFound: () => navigateReplace("/"),
});

const LoginPage = defineAsyncComponent(
  () => import("@/modules/auth/views/login.vue")
);
</script>

<template>
  <uk-app-wrap :getLocalData="getLocalData" :setLocalData="setLocalData"
    ><LoginPage v-if="!isAuthorised" />
    <component v-else-if="ready && !!el" :is="el"
  /></uk-app-wrap>
</template>

<style lang="scss">
:root {
  --uk-lines-borders: #d9d9d9;
  --uk-ptext-lborders: #4a4d63;
  --uk-error: #eb5757;
  --uk-accent: #024ba7;
  --uk-background: #f2f6f9;
  --uk-text-color: #000000;
  --uk-inverted-text-color: var(--uk-background);
  --uk-main-color: var(--uk-text-color);
  --uk-text-transparent: #363c4833;
  --uk-text-passive-filter: #a3afc8;
  --uk-background-item: #ffffff;
  --uk-shadows: #00000033;
  --uk-background-modal: #363c48ad;
  --uk-background-tablecard: #f0f0f088;

  color: var(--uk-text-color);
  background-color: var(--uk-background);

  --uk-button-fg: #ffffff;

  --uk-animation-time: 0.5s;
  --uk-animation-fn: ease;

  --uk-table-header-bg: #377bd3;
  --uk-table-header-fg: #ffffff;

  --uk-tooltip-bg: #ffffff;
  --uk-tooltip-fg: var(--uk-text-color);

  --uk-filled-input-bg: #f6f5f4d9;

  --uk-header-color: var(--uk-white);

  --uk-orange: #f2994a;
  --uk-blue: #2d9cdb;
  --uk-green: #4ead4e;
  --uk-red: #eb5757;
  --uk-black: #363c48;
  --uk-white: #ffffff;

  --nav-header-height: 122px;
}

html,
body {
  margin: 0 !important;
  overscroll-behavior: none !important;
}

@media (max-width: 1024px) {
  :root {
    --nav-header-height: 70px;
  }
}
@media (min-width: 1025px) {
  .app-menu {
    height: 52px !important;
  }
}
.v-modal-fluid {
  .modal-dialog {
    @media (min-width: 1024.1px) {
      min-width: 90%;
    }
  }
  .modal-content {
    @media (min-width: 1024.1px) {
      background-color: var(--vz-body-bg);
    }
  }
}

.uk-lightdom-input:focus + .uk-lightdom-label,
.uk-lightdom-input:not(:placeholder-shown) + .uk-lightdom-label,
.uk-lightdom-input:-webkit-autofill + .uk-lightdom-label,
.uk-lightdom-input:autofill + .uk-lightdom-label {
  display: var(--active-label-display);
  top: var(--active-label-top);
  font-size: 10px;
  line-height: 10px;
}

/* Убрать после удаления сторонних глобальных стилей */
.uk-lightdom-input {
  box-sizing: content-box !important;
}
</style>
